import React from 'react';
//import {authRoles} from '../../auth';

export const UserCargosListConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['master', 'rh', 'rh_not_signer', 'director'],
    routes: [{
        path: '/cargos-list',
        component: React.lazy(() =>
            import ('./UserCargosList'))
    }]
};